import { AddressDTO } from '../DTOs/AddressDTO';

export class Address {
  public static getEmptyAddress() {
    return new Address(undefined, '', '', '', '', '');
  }

  public static fromDTO(addressDTO: AddressDTO) {
    return new Address(
      addressDTO.id.toString(),
      addressDTO.fullName,
      addressDTO.street,
      addressDTO.city,
      addressDTO.postalCode,
      addressDTO.country,
    );
  }

  id?: string;
  fullName: string;
  street: string;
  city: string;
  postalCode: string;
  country: string;

  constructor(id: string | undefined, fullName: string, street: string, city: string, post: string, country: string) {
    this.id = id;
    this.fullName = fullName;
    this.street = street;
    this.city = city;
    this.postalCode = post;
    this.country = country;
  }
}
